import { FormTitleResponse } from '../../../../types/api/endpoints/form/formTitle.types';
import { FORM_ENDPOINTS } from '../../../../utils/api/endpoints/formEndpoints';
import { RegisterFormVariants } from './LaunchingRegisterForm/LaunchingRegisterForm.types';

const PREFIX = '[formTitleQuery]';

export const FORM_TITLE_QUERY_KEY = 'FORM_TITLE';

export const FormTitleQuery = async (variant: RegisterFormVariants) => {
  console.log(PREFIX, `Fetching form title...`);
  const response = await FORM_ENDPOINTS.title(variant);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  // console.log('----------------------->', json)

  console.log(PREFIX, `Received form title.`);
  return json as FormTitleResponse;
};
